import { render, staticRenderFns } from "./VideoCardSkeleton.vue?vue&type=template&id=cee05fec&scoped=true"
import script from "./VideoCardSkeleton.vue?vue&type=script&lang=js"
export * from "./VideoCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./VideoCardSkeleton.vue?vue&type=style&index=0&id=cee05fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee05fec",
  null
  
)

export default component.exports